// /* eslint-disable */
/**
 *  @fileOverview MyUniStart Module, loads checklist, login features etc.
 *
 *  @author       Aaron Chapman, Chris Hill
 *
 */

function MyUniStartModule (disableBodyScroll, enableBodyScroll, Pristine, sha256, axios) {
  /**
   * @description Initialises MyUniStart features.
   *
   * @example
   * //
   * @returns {boolean} // null.
   */
  const checklist = document.querySelector('.checklist')
  const checklistTrigger = document.querySelector('.checklistTrigger')
  const navTrigger = document.querySelector('.navTrigger')
  const navWrap = document.querySelector('.mobileMenuWrap')
  const profileTrigger = document.querySelector('.profile')
  const myUniStartHeader = document.querySelector('.header--myUniStart')
  const registrationHolder = document.querySelector('.myUniStart__registrationHolder')
  const registrationForm = document.querySelector('.myUniStart__registrationForm')
  const feedHolderRegistration = document.querySelector('.myUniStart__registrationFeedback')
  const articlesList = '/designs/ecu-internet-2019/helpers/my-uni-start/articles-json'
  const server = document.location.href.includes('wwwqa.ecu.edu.au') ? 'https://webservicesdev.web.ecu.edu.au/myunistart/' : 'https://webservices.web.ecu.edu.au/myunistart/'
  let disable = false
  let feedHolderLogin = null
  let loginForm = null
  let articles = []
  let userCohort = null
  let pristineLogin, pristineRegistration
  let pristineConfig = {
    // class of the parent element where the error/success class is added
    classTo: 'formGroup',
    errorClass: 'has-danger',
    successClass: 'has-success',
    // class of the parent element where error text element is appended
    errorTextParent: 'formGroup',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'text-help'
  }

  let cookie = getCookie('ECU-unistart')
  let hash = ''
  let initials = '' // The initials of the user

  /**
   * @description Initialises the MyUniStart login and checklist.
   *
   * @example
   * // returns NULL
   */
  this.init = function () {
    console.log('Running... Latest')

    /**
     * Check for disable metadata and update var
     */
    const disabledMeta = document.head.querySelector('[name~=myunistart-login-disabled][content]')

    if (disabledMeta !== null) {
      if (disabledMeta.content === 'true') {
        disable = true
      }
    }

    axios.get(articlesList)
      .then(response => {
        articles = response.data
        buildCards()
        buildArticleNav()

        /**
         * If API needs to be disabled eg WebCMS upgrade etc
         */
        if (disable) {
          disablePage()
        } else {
          /**
           * Check if cookie is set, if not show the decision code, if set to skip clear everything else retrieve data
           */
          if (typeof cookie === 'undefined') {
            profileTrigger.classList.add('profile--inactive')
            checkRegistered()
          } else {
            console.log(JSON.parse(cookie))
            const data = JSON.parse(cookie)

            /**
             * Check for null hash in cookie
             */
            if (data.hash !== null && typeof data.hash === 'string') {
              const url = server + 'user-get.php'
              hash = data.hash

              axios.post(url, data)
                .then(function (response) {
                  console.log(response.data)
                  if (response.data.success) {
                    processAssetData(response.data.user)
                  }
                })
                .catch(function (error) {
                  console.log(error)
                })
            } else {
              profileTrigger.classList.add('profile--inactive')
              checkRegistered()
            }
          }

          buildLogin()
          createTriggers()
        }
      })
      .catch(e => {
        console.log(e)
      })
  }

  /**
   * @description Builds disable msg disable login
   *
   * @example
   * // returns NULL
   */
  let disablePage = function () {
    console.log('page is disabled')
    profileTrigger.setAttribute('disabled', true)
    profileTrigger.classList.add('profile--inactive')
    profileTrigger.querySelector('.profile__name').innerHTML = 'Login'
    profileTrigger.querySelector('.profile__arrow').classList.remove('deactivateItems')
    let icon = profileTrigger.querySelector('.profile__icon')
    icon.querySelector('span').innerHTML = ''
    icon.querySelector('.fa-user').classList.remove('deactivateItems')

    if (checklist !== null) {
      if (checklist.classList.contains('checklist--unregistered')) {
        let registerNotificationHTML = `
          <div class="checklist__registerNotification">
            <h2 class="class="base__heading base__heading--medium">We're doing a little housekeeping today.</h2>
            <p>So you can't register or login until tomorrow (sorry). But you can browse articles...</a>
          </div>`

        let registerNotification = document.createElement('div')
        registerNotification.innerHTML = registerNotificationHTML
        registerNotification.className = 'checklist__registerNotificationWrap'

        checklist.appendChild(registerNotification)
      }
    }

    let bannerHTML = `
      <p class="notification__text">We're doing a little housekeeping today, so you can't register or login until tomorrow (sorry). But you can browse articles...</p>
    `
    let banner = document.createElement('div')
    banner.innerHTML = bannerHTML
    banner.className = 'notification'

    let firstChild = document.querySelector('body').firstChild

    document.querySelector('body').insertBefore(banner, firstChild)

    createTriggers()
  }

  /**
   * @description Checks if user is registered and if not appends message.
   *
   * @example
   * // returns NULL
   */
  let checkRegistered = function () {
    if (checklist !== null) {
      if (checklist.classList.contains('checklist--unregistered')) {
        let registerNotificationHTML = `
          <div class="checklist__registerNotification">
            <h2 class="base__heading base__heading--medium">Register here for your Uni Start checklist.</h2>
            <p>Get your ECU experience off to a great start by understanding the important stuff.</p>
            <a href="/my-uni-start/registration" class="button button--white" data-buttonitem="primary-register-for-account" data-buttonpagelocation="my-uni-start-checklist" aria-label="Register for My Uni Start">Register now</a>
          </div>`

        let registerNotification = document.createElement('div')
        registerNotification.innerHTML = registerNotificationHTML
        registerNotification.className = 'checklist__registerNotificationWrap'

        checklist.appendChild(registerNotification)
      }
    }
  }

  /**
   * @description Appends login form and calls function to create triggers.
   *
   * @example
   * // returns NULL
   */
  let buildLogin = function () {
    if (profileTrigger !== null) {
      let loginFormHTML = `
        <form action="#">
          <!--<div class="formInput">
            <label for="loginForm__name">Name</label>
            <input type="text" id="loginForm__name" name="loginForm__name">
          </div>-->
          <div class="formInput formGroup">
            <label for="loginForm__email">Email</label>
            <input type="email" id="loginForm__email" name="loginForm__email" required>
          </div>
          <div class="formInput">
            <input type="submit" value="Login">
          </div>
          <div class="loginFeedback"></div>
          <div class="formInput loginForm__registrationLink">
            <a href="/my-uni-start/registration" class="button button--textOnly button--banner" data-linkitem="secondary-register-for-account" data-linkpagelocation="my-uni-start-header">Register</a>
          </div>
        </form>`

      let siteHeaderDiv = document.createElement('div')
      siteHeaderDiv.innerHTML = loginFormHTML
      siteHeaderDiv.className = 'loginForm'

      myUniStartHeader.appendChild(siteHeaderDiv)

      /**
       * Assign form element to loginForm
       */
      loginForm = myUniStartHeader.querySelector('form')
      feedHolderLogin = document.querySelector('.loginFeedback')

      pristineLogin = new Pristine(loginForm, pristineConfig)
    }
  }

  /**
   * @description Appends login form and calls function to create triggers.
   *
   * @example
   * // returns NULL
   */
  let buildCards = function () {
    let url = document.location.href
    let section = []
    let html = ''
    let articlesPrimary = document.querySelector('[data-js-article="articlesPrimary"]')
    let articlesSecondary = document.querySelector('[data-js-article="articlesSecondary"]')

    /**
     * Get the relevant list of pages to make cards from based on URL
     */
    if (url.indexOf('/get-started') > 0) {
      section = articles['Get Started']
    } else if (url.indexOf('/preparing') > 0) {
      section = articles['Preparing']
    } else if (url.indexOf('/enrolling') > 0) {
      section = articles['Enrolling']
    } else if (url.indexOf('/orientation') > 0) {
      section = articles['Orientation']
    }

    /**
     * Check if on landing page with article list
     */
    if (articlesPrimary !== null) {
      html += `<h2 class="cardList__span base__heading base__heading--medium">Essential information to help you get started</h2>`

      /**
       * Build html for essential articles
       */
      section.forEach((card) => {
        if (card['asset_metadata_article.essential'] === 'Y') {
          if (userCohort === null || card['asset_metadata_user.interest.cohort'] === 'all-students' || userCohort === card['asset_metadata_user.interest.cohort']) {
            html += `
              <div class="card card--contained">
                <img src="${card['asset_metadata_article.card.image']}" alt="">
                <div class="card__highlight">Essential information</div>
                <div class="card__text">
                  <h3 class="base__heading base__heading--small">${card.asset_name}</h3>
                  ${card['asset_metadata_presentation.summary.1']}
                  <a href="${card.asset_url}" class="button button--textOnly" aria-label="More information about ${card.asset_name}">Read more</a>
                </div>
              </div>`
          }
        }
      })

      articlesPrimary.innerHTML = html

      /**
       * Check if on landing page with other info
       */
      if (articlesSecondary !== null) {
        console.log('Render other info')
        html = `<h2 class="cardList__span base__heading base__heading--medium">Other information that's worth a look</h2>`

        /**
         * Build html for essential articles
         */
        section.forEach((card) => {
          if (card['asset_metadata_article.essential'] === 'N') {
            if (userCohort === null || card['asset_metadata_user.interest.cohort'] === 'all-students' || userCohort === card['asset_metadata_user.interest.cohort']) {
              html += `
                <div class="card card--contained">
                  <img src="${card['asset_metadata_article.card.image']}" alt="">
                  <div class="card__text">
                    <h3 class="base__heading base__heading--small">${card.asset_name}</h3>
                    ${card['asset_metadata_presentation.summary.1']}
                    <a href="${card.asset_url}" class="button button--textOnly button--banner" aria-label="More information about ${card.asset_name}">Read more</a>
                  </div>
                </div>`
            }
          }
        })

        articlesSecondary.innerHTML = html
      }
    }
  }

  /**
   * @description Builds prev and next nav on article pages
   *
   * @example
   * // returns NULL
   */
  let buildArticleNav = function () {
    let nav = document.querySelector('.articleNavigation')
    let url = document.location.href
    let section = []
    let prevURL = null
    let prevText = null
    let nextURL = null
    let nextText = null
    let html = ''

    if (nav !== null) {
      console.log(articles)
      /**
       * Get the relevant list of pages to make cards from based on URL
       */
      if (url.indexOf('/get-started') > 0) {
        section = articles['Get Started']
      } else if (url.indexOf('/preparing') > 0) {
        section = articles['Preparing']
      } else if (url.indexOf('/enrolling') > 0) {
        section = articles['Enrolling']
      } else if (url.indexOf('/orientation') > 0) {
        section = articles['Orientation']
      }

      /**
       * Loop through array looking for current page based on URLs
       */
      section.forEach((page, index) => {
        /**
         * Only do things on current page
         */
        if (url === page.asset_url) {
          if (index === 0) {
            /**
             * If first page check if logged in and workout next page based on cohort
             */
            if (userCohort !== null) {
              for (let i = 1; i < section.length; i++) {
                let c = section[i]['asset_metadata_user.interest.cohort']
                if (c === 'all-students' || c === userCohort) {
                  nextURL = section[i].asset_url
                  nextText = section[i].asset_short_name
                  break
                }
              }
            } else {
              nextURL = section[1].asset_url
              nextText = section[1].asset_short_name
            }
          } else if (index === section.length - 1) {
            /**
             * If last page check if logged in and workout prev page based on cohort
             */
            if (userCohort !== null) {
              for (let i = section.length - 2; i >= 0; i--) {
                let c = section[i]['asset_metadata_user.interest.cohort']
                if (c === 'all-students' || c === userCohort) {
                  prevURL = section[i].asset_url
                  prevText = section[i].asset_short_name
                  break
                }
              }
            } else {
              prevURL = section[section.length - 2].asset_url
              prevText = section[section.length - 2].asset_short_name
            }
          } else {
            /**
             * If any other page page check if logged in and workout next and prev pages based on cohort
             */
            if (userCohort !== null) {
              for (let i = index + 1; i < section.length; i++) {
                let c = section[i]['asset_metadata_user.interest.cohort']
                if (c === 'all-students' || c === userCohort) {
                  nextURL = section[i].asset_url
                  nextText = section[i].asset_short_name
                  break
                }
              }

              for (let i = index - 1; i >= 0; i--) {
                let c = section[i]['asset_metadata_user.interest.cohort']
                if (c === 'all-students' || c === userCohort) {
                  prevURL = section[i].asset_url
                  prevText = section[i].asset_short_name
                  break
                }
              }
            } else {
              nextURL = section[index + 1].asset_url
              nextText = section[index + 1].asset_short_name
              prevURL = section[index - 1].asset_url
              prevText = section[index - 1].asset_short_name
            }
          }
        }
      })

      /**
       * If next or prev set then add to html
       */
      if (prevURL !== null) {
        html += `<a href="${prevURL}" class="articleNavigation__previous button button--textOnly"><i class="fa fa-angle-left"></i>${prevText}</a>`
      }

      if (nextURL !== null) {
        html += `<a href="${nextURL}" class="articleNavigation__next button button--textOnly">${nextText}<i class="fa fa-angle-right"></i></a>`
      }

      nav.innerHTML = html
    }
  }

  /**
   * @description Switches binding and style of profileTrigger button.
   *
   * @example
   * // returns NULL
   */
  let switchProfiletrigger = function () {
    if (!profileTrigger.classList.contains('profile--inactive')) {
      profileTrigger.querySelector('.profile__name').innerHTML = 'Logout'
      profileTrigger.querySelector('.profile__arrow').classList.add('deactivateItems')
      profileTrigger.removeEventListener('click', loginExpand, true)
      profileTrigger.addEventListener('click', logOut, true)
      let icon = profileTrigger.querySelector('.profile__icon')
      icon.querySelector('span').innerHTML = initials
      icon.querySelector('.fa-user').classList.add('deactivateItems')
    } else {
      profileTrigger.querySelector('.profile__name').innerHTML = 'Login'
      profileTrigger.querySelector('.profile__arrow').classList.remove('deactivateItems')
      profileTrigger.removeEventListener('click', logOut, true)
      profileTrigger.addEventListener('click', loginExpand, true)
      let icon = profileTrigger.querySelector('.profile__icon')
      icon.querySelector('span').innerHTML = ''
      icon.querySelector('.fa-user').classList.remove('deactivateItems')
    }
  }

  /**
   * @description Binds events to elements.
   *
   * @example
   * // returns NULL
   * @returns {boolean} - NULL.
   */
  let createTriggers = function () {
    if (checklist == null && checklistTrigger !== null) {
      checklistTrigger.parentNode.removeChild(checklistTrigger)
    }
    if (checklistTrigger !== null) {
      checklistTrigger.addEventListener('click', checklistExpand)
    }
    if (navTrigger !== null) {
      navTrigger.addEventListener('click', navExpand)
    }

    /**
     * Only run code if page not disabled
     */
    if (!disable) {
      if (profileTrigger !== null) {
        switchProfiletrigger()
      }
      if (loginForm !== null) {
        loginForm.addEventListener('submit', submitLogin)
      }
      if (registrationForm !== null) {
        registrationForm.addEventListener('submit', submitRegistration)
        pristineRegistration = new Pristine(registrationForm, pristineConfig)

        const elem = registrationForm.querySelector('#course')

        /**
         * Validator checks that only alpha numeric characters are used
         */
        pristineRegistration.addValidator(elem, function (value) {
          let reg = /^[a-z0-9]+$/i
          if (value.match(reg)) {
            return true
          }
          return false
        }, 'Course codes are 3-character A-Z 0-9', 2, false)
      }
    }
  }

  /**
   * @description Pops the checklist out from the right in mobile????
   *
   * @example
   * // returns NULL
   */
  let checklistExpand = function () {
    if (navWrap !== null) {
      if (navWrap.classList.contains('mobileMenuWrap--active')) {
        navExpand()
      }
    }
    checklist.classList.toggle('checklist--active')
    document.querySelector('body').classList.toggle('menu-lock')

    if (checklist.classList.contains('checklist--active')) {
      disableBodyScroll(checklist)
    } else {
      enableBodyScroll(checklist)
    }
  }

  /**
   * @description Pops the checklist out from the right in mobile
   *
   * @example
   * // returns NULL
   */
  let navExpand = function () {
    if (checklist !== null) {
      if (checklist.classList.contains('checklist--active')) {
        checklistExpand()
      }
    }
    navWrap.classList.toggle('mobileMenuWrap--active')

    navTrigger.querySelector('svg').classList.toggle('fa-bars')
    navTrigger.querySelector('svg').classList.toggle('fa-times')
    document.querySelector('body').classList.toggle('menu-lock')

    if (navWrap.classList.contains('mobileMenuWrap--active')) {
      disableBodyScroll(navWrap)
    } else {
      enableBodyScroll(navWrap)
    }
  }

  /**
   * @description Make the login form appear.
   *
   * @example
   * // returns NULL
   */
  let loginExpand = function () {
    document.querySelector('.profile__arrow').classList.toggle('fa-caret-down')
    document.querySelector('.profile__arrow').classList.toggle('fa-caret-up')
    document.querySelector('.loginForm').classList.toggle('loginForm--visible')

    feedHolderLogin.innerHTML = ''
    loginForm.querySelector('#loginForm__email').value = ''
  }

  /**
   * @description Logout.
   *
   * @example
   * // returns NULL
   */
  let logOut = function () {
    document.cookie = 'ECU-unistart =; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;'
    profileTrigger.classList.add('profile--inactive')
    switchProfiletrigger()

    /**
     * Reset checklist
     */
    if (checklist !== null) {
      let items = checklist.querySelectorAll('.checklist__step')
      checklist.classList.add('checklist--unregistered')
      checkRegistered()

      /**
       * If view count is set remove
       */
      let viewCount = checklist.querySelector('#viewCount')
      if (viewCount !== null) {
        viewCount.parentNode.removeChild(viewCount)
      }

      /**
       * Loop through checklist steps list items and remove checked class
       */
      items.forEach((item) => {
        item.classList.remove('checklist__step--checked')
      })

      /**
       * Rebuild articles
       */
      userCohort = null
      buildCards()
      buildArticleNav()
    }
  }

  /**
   * @description Validates login form then sends data to DB
   *
   * @param {Object} event - On submit event.
   *
   * @example
   * // returns NULL
   */
  let submitLogin = function (event) {
    event.preventDefault()

    let valid = pristineLogin.validate()
    console.log(valid)
    loginForm.querySelector('input[type="submit"]').disabled = true
    feedHolderLogin.innerHTML = `We're logging you in...any second now...`

    hash = sha256(encodeURI(document.getElementById('loginForm__email').value)).toString()

    const data = {
      hash: hash
    }
    const url = server + 'user-get.php'

    axios.post(url, data)
      .then(function (response) {
        console.log(response.data)
        if (response.data.success) {
          rebuildCookie(response.data.user)
        } else {
          feedHolderLogin.innerHTML = `Oops, that email address doesn't look right. Please try again.`
          loginForm.querySelector('input[type="submit"]').disabled = false
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  }

  /**
   * @description Validates registration form then sends data to DB
   *
   * @param {Object} event - On submit event.
   *
   * @example
   * // returns NULL
   */
  let submitRegistration = function (event) {
    event.preventDefault()
    let valid = pristineRegistration.validate()
    console.log(valid)

    if (valid) {
      /* eslint-disable-next-line no-undef */
      var response = grecaptcha.getResponse()

      /**
       * Check has passed recaptcha
       */
      if (response.length !== 0) {
        feedHolderRegistration.innerHTML = `
          <h2 class="base__heading base__heading--medium">This may take a moment or two...</h2>
          <p>We're just setting up your checklist. To keep track of where you're at, you can login anytime using your email address.</p>`
        feedHolderRegistration.classList.remove('deactivateItems')
        registrationHolder.classList.add('deactivateItems')
        hash = sha256(encodeURI(document.getElementById('regemail').value)).toString()

        /**
         * Check hash was created properly
         */
        if (hash !== null && typeof hash === 'string') {
          const url = server + 'user-create.php'
          let data = {
            hash: hash,
            firstname: encodeURI(document.getElementById('firstname').value.trim()),
            lastname: encodeURI(document.getElementById('lastname').value.trim()),
            email: encodeURI(document.getElementById('regemail').value.trim()),
            cohort: document.querySelector('input[name="cohort"]:checked').value,
            course: encodeURI(document.getElementById('course').value.trim())
          }

          axios.post(url, data)
            .then(function (response) {
              if (response.data.success) {
                var data = {
                  hash: hash
                }

                setCookie(JSON.stringify(data))

                /**
                 * Redirect to MyUniStart home
                 */
                window.location.href = window.location.href.split('/registration')[0]
              } else {
                feedHolderRegistration.innerHTML = response.data.error
                feedHolderRegistration.classList.remove('deactivateItems')
              }
            })
            .catch(function (error) {
              console.log(error)
            })
        } else {
          feedHolderRegistration.innerHTML = `
            <p>There is a problem creating your account. Please try a different browser.</p>
          `
          feedHolderRegistration.classList.remove('deactivateItems')
        }
      } else {
        let fb = document.createElement('div')
        fb.className = 'pristine-error text-help recaptcha-error'

        const recap = document.querySelector('.g-recaptcha')

        recap.parentNode.insertBefore(fb, recap.nextSibling)

        fb.innerHTML = 'You must prove you are not a robot!'
      }
    }
  }

  /**
   * @description Creates a cookie with the value sent through
   *
   * @param {string} text - Text to set the cooki to.
   *
   * @example
   * // returns NULL
   */
  let setCookie = function (text) {
    document.cookie = 'ECU-unistart = ' + text + ';secure;max-age=31536000;path=/'
  }

  /**
   * @description Gets cookie value by name. Function declaration used as function is called before init.
   *
   * @param {string} name - Name to look for.
   *
   * @example //
   * @returns {string} Content of cookie.
   */
  function getCookie (name) {
    var value = '; ' + document.cookie
    var parts = value.split('; ' + name + '=')
    if (parts.length === 2) return parts.pop().split(';').shift()
  }

  /**
   * @description Process the DB fields
   *
   * @param {Object} result - API return object.
   *
   * @example //
   * // @returns NULL
   */
  let processAssetData = function (result) {
    initials = decodeURI(result['user.details.first.name']).charAt(0).toUpperCase() + decodeURI(result['user.details.last.name']).charAt(0).toUpperCase()

    if (document.querySelector('.loginForm') !== null) {
      document.querySelector('.loginForm').classList.remove('loginForm--visible')
      switchProfiletrigger()
    }

    if (checklist !== null) {
      checklist.classList.remove('checklist--unregistered')

      if (checklist.querySelector('.checklist__registerNotificationWrap') !== null) {
        checklist.querySelector('.checklist__registerNotificationWrap').remove()
      }
    }

    console.log('process asset data')
    console.log(result)
    updateChecklist(result)

    /**
     * Build list of articles based on cohort
     */
    userCohort = result['user.interest.cohort']
    buildCards()
    buildArticleNav()

    const url = server + 'user-update.php'

    /**
     * Look for pages that have a timer function. If found check for item type and wait 10 secs to update db
     * Note, body attributes converted to camelcase so replace in code below
     */
    let cList = document.querySelector('body').dataset.checklistItem
    let tType = document.querySelector('body').dataset.triggerType
    if (tType !== undefined && tType !== '') {
      if (cList !== undefined && cList !== '') {
        /**
         * If already set ignore
         */
        if (result[cList] === '' || result[cList] === null) {
          console.log('timer func')

          window.setTimeout(function () {
            let data = {
              hash: hash,
              field: cList,
              value: 'Y'
            }

            axios.post(url, data)
              .then(function (response) {
                console.log(response.data)
                if (response.data.success === true) {
                  let items = checklist.querySelectorAll('.checklist__step')

                  /**
                   * Loop through looking for checklist item and set to checked
                   */
                  items.forEach((item) => {
                    if (item.dataset.checklistItem === cList) {
                      item.classList.add('checklist__step--checked')
                    }
                  })

                  /**
                   * If view count is set update viewed total
                   */
                  let viewCount = checklist.querySelector('#viewCount')
                  if (viewCount !== null) {
                    let sp = viewCount.querySelector('span')

                    sp.innerHTML = parseInt(sp.innerHTML) + 1
                  }
                }
              })
              .catch(function (error) {
                console.log(error)
              })
          }, 10 * 1000)
        }
      }
    }

    /**
     * Check if on remote content page then look for checklist type and update DB
     * This is for button triggers
     */
    if (document.location.href.includes('?sq_content_src=')) {
      if (result[cList] === '' || result[cList] === null) {
        let data = {
          hash: hash,
          field: cList, // attribute converted to camelCase
          value: 'Y'
        }

        axios.post(url, data)
          .then(function (response) {
            console.log(response.data)
            if (response.data.success === true) {
              let items = checklist.querySelectorAll('.checklist__step')

              /**
               * Loop through looking for checklist item and set to checked
               */
              items.forEach((item) => {
                if (item.dataset.checklistItem === cList) {
                  item.classList.add('checklist__step--checked')
                }
              })

              /**
               * If view count is set update viewed total
               */
              let viewCount = checklist.querySelector('#viewCount')
              if (viewCount !== null) {
                let sp = viewCount.querySelector('span')

                sp.innerHTML = parseInt(sp.innerHTML) + 1
              }
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      }
    }
  }

  /**
   * @description Loop through the checklist sections and highlight items that have been completed
   *
   * @param {Object} data - User asset data.
   *
   * @example //
   * // @returns NULL
   */
  let updateChecklist = function (data) {
    console.log(data)
    if (checklist !== null) {
      let items = checklist.querySelectorAll('.checklist__step')
      let viewedPages = 0
      let totalPages = 0

      /**
       * Loop through checklist steps list items
       */
      items.forEach((item) => {
        /**
         * Check if item is the current page, if so add active class
         */
        const body = document.querySelector('body')
        if (typeof body.dataset.checklistItem !== 'undefined') {
          if (item.dataset.checklistItem === body.dataset.checklistItem) {
            item.classList.add('checklist__step--active')
          }
        }

        let cohort = item.dataset.cohort

        if (cohort !== '' && cohort !== null) {
          if (data['user.interest.cohort'] !== cohort && cohort !== 'all-students') {
            item.classList.add('deactivateItems')
          }
        }

        /**
         * Loop through data for user and check if page matches
         */
        for (var property in data) {
          /**
           * Check if the stage data attribute is a matching sub string of the metadata key
           * Note checklist-item attribute is being converted to camelcase
           */
          let itemdata = item.dataset.checklistItem
          if (property.indexOf(itemdata) > -1) {
            /**
             * If metadata not empty add class to show tick and update metadata
             */
            if (data[property] !== '' && data[property] !== null) {
              item.classList.add('checklist__step--checked')
            }
          }
        }
      })

      /**
       * Loop through data and count pages viewed
       */
      for (var property in data) {
        /**
         * Only count page metadata in count
         */
        if (!property.includes('user')) {
          /**
           * Increment view pages if page is set to Y
           */
          if (data[property] === 'Y') {
            viewedPages++
          }
        }
      }

      if (data['user.interest.cohort'] === 'international-student') {
        totalPages = items.length
      } else {
        totalPages = checklist.querySelectorAll('.checklist__step:not([data-cohort="international-student"])').length
      }

      /**
       * Create page count text and insert after header text
       */
      const h2 = checklist.querySelector('h2')
      let para = document.createElement('p')
      para.className = 'base__heading base__heading--small'
      para.id = 'viewCount'
      para.innerHTML = `<span>${viewedPages}</span> of ${totalPages} articles read`

      h2.parentNode.insertBefore(para, h2.nextSibling)
    }
  }

  /**
   * @description Checks for error code and if not found creates cookie with search result
   *
   * @param {Object} result - API return object.
   *
   * @example //
   * // @returns NULL
   */
  let rebuildCookie = function (result) {
    console.log(result)
    loginForm.querySelector('input[type="submit"]').disabled = false

    var data = {
      hash: result.hash
    }

    setCookie(JSON.stringify(data))

    console.log('Login success, call page process function')

    processAssetData(result)

    profileTrigger.classList.remove('profile--inactive')
    switchProfiletrigger()
  }
}

module.exports = MyUniStartModule
